import React, { useState, useEffect } from "react" ;

import AdminAppSidebar from "./Sidebar/AdminAppSidebar";
import AdminAppBody from "./Body/AdminAppBody";
import AdminModuleProvider from "./AdminModuleProvider";

const WieldyApplicationModuleAdmin = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;
    const [ width, setWidth] = useState ( props.width ) ;
    const pageStyle = { height: '' + (+height-1) + 'px' } ;

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">
                <div className="dt-module" style={pageStyle}>
                    <AdminModuleProvider>
                        <AdminAppSidebar key='sidebar' title={'Admin'} iconName={'icon-family'} height={height} width={width}/>
                        <AdminAppBody key='body' height={height}/>
                    </AdminModuleProvider>
                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModuleAdmin;